<div class="documentsummary-current-action" *ngIf="firstDocumentActor">
    <div class="row row-cols-12">
        <!-- Showe the NEXT action for Document -->
        <div class="d-inline-block">

            <!-- Needed for the Start/Continue button flow -->
            <span id="{{navigationId}}"></span>


            <!-- ACTIVE Action button -->
            <button class="btn btn-sm btn-success" id="{{GenerateActionId(firstDocumentActor)}}"
                [disabled]="!currentActorIsForDocument" (click)="triggerActorModal()"
                translate="Button.{{firstDocumentActor.action}}"></button>
                
            <!-- Needed for the Action badge line thingie -->
            <ng-container *ngFor="let futureCurrentActor of allCurrentActors; index as i">
                <ng-container *ngIf="futureCurrentActor.id != firstDocumentActor.id">
                    <div [style.margin-bottom.px]="[ 25 * i]" id="{{GenerateActionId(futureCurrentActor)}}"></div>
                </ng-container>
            </ng-container>

        </div>
    </div>
</div>